import React from 'react';
import PropTypes from 'prop-types';
import WatchlistStar from './watchlist-star';
import * as styles from './single-marker.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MARKER_FILLS = {
  default: '#0b2047',
  isFeatured: '#e81043',
  isVisited: '#7e8594',
  isVisited_isFeatured: '#f1708e'
};
var SingleMarker = props => {
  var fill = null;
  if (props.isVisited) {
    if (props.isFeatured) {
      fill = MARKER_FILLS.isVisited_isFeatured;
    } else {
      fill = MARKER_FILLS.isVisited;
    }
  } else if (props.isFeatured) {
    fill = MARKER_FILLS.isFeatured;
  } else {
    fill = MARKER_FILLS.default;
  }
  return ___EmotionJSX("div", {
    css: styles.marker
  }, props.count && props.count > 1 && ___EmotionJSX("div", {
    css: styles.markerLabel
  }, props.count), ___EmotionJSX("svg", {
    viewBox: "0 0 18 26",
    css: styles.mapMarkerIcon
  }, ___EmotionJSX("g", {
    fill: fill,
    fillRule: "evenodd"
  }, ___EmotionJSX("ellipse", {
    cx: "9",
    cy: "24",
    fill: "#A9AFBA",
    fillRule: "nonzero",
    opacity: ".6",
    rx: "4",
    ry: "2"
  }), ___EmotionJSX("path", {
    d: "M6.632 17.991C2.81 16.934 0 13.38 0 9.156 0 4.099 4.03 0 9 0s9 4.1 9 9.156c0 4.223-2.81 7.778-6.632 8.835l-2.107 5.717c-.144.39-.375.398-.522 0L6.632 17.99z"
  })), props.isInWatchlist && ___EmotionJSX(WatchlistStar, null)));
};
SingleMarker.propTypes = {
  count: PropTypes.number,
  lat: PropTypes.number.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  lng: PropTypes.number.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  isInWatchlist: PropTypes.bool,
  isFeatured: PropTypes.bool,
  isVisited: PropTypes.bool
};
SingleMarker.defaultProps = {
  count: 1,
  isFeatured: false,
  isVisited: false,
  isInWatchlist: false
};
export default SingleMarker;